import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.random.words(3);
  },

  description() {
    return faker.lorem.sentence();
  },

  pattern() {
    return `${faker.internet.url()}/[PATTERN]`;
  },

  svgUrl() {
    return `${faker.internet.url()}/image.svg`;
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(job, server) {
    job.update({
      tradePartner: server.create('trade-partner'),
      shopType: server.create('category', 'shopTyp'),
    });
  },
});
